<template>
  <modal :show="visible" modalClasses="modal-xl">
    <template #header></template>
    <h3 class="text-center">
      {{
        customerContact.id ? "Cập nhật người liên hệ" : "Thêm mới người liên hệ"
      }}
    </h3>
    <loading
      :active.sync="isPending"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
      <form role="form" @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="6">
            <ValidationProvider
              name="Tên người liên hệ"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                label="Tên người liên hệ"
                :error="errors[0]"
                v-model="customerContact.name"
                :valid="errors.length == 0"
              ></base-input>
            </ValidationProvider>
            <base-input
              label="Số điện thoại"
              v-model="customerContact.phone"
            ></base-input>
          </b-col>
          <b-col cols="6">
            <base-input
              label="Chức vụ"
              v-model="customerContact.position"
            ></base-input>
            <base-input
              label="Email"
              v-model="customerContact.email"
            ></base-input>
          </b-col>
          <b-col cols="6">
            <base-input
              label="Địa chỉ"
              v-model="customerContact.address"
            ></base-input>
          </b-col>
          <b-col cols="6">
            <div class="form-group">
              <label for="">Loại liên hệ</label>
              <select v-model="customerContact.type" class="form-control">
                <option value="SHIP">Người nhận hàng</option>
                <option value="PAYMENT">Người thanh toán</option>
                <option value="ORDER" selected>Người đặt hàng</option>
              </select>
            </div>
          </b-col>
        </b-row>
      </form>
    </ValidationObserver>
    <button type="button" @click="handleClose" class="btn btn-secondary">
      Đóng (Esc)
    </button>
    <button type="button" @click="doSave(1)" class="btn btn-success">
      Lưu tiếp (Shift + F4)
    </button>
    <button type="button" @click="doSave(0)" class="btn btn-dark">
      Lưu đóng (F4)
    </button>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>

<script>
import { customerService } from "@/_services";
export default {
  data() {
    return {
      visible: false,
      steps: ["Thông tin", "Chi tiết", "Hình đại diện"],
      customerContact: {
        type: "ORDER",
        isDefault: true
      },
      customer: {},
      uploadPreview: "/img/placeholder/default.jpg",
      isPending: false
    };
  },
  methods: {
    doSave(type) {
      if (!this.visible) return;
      var self = this;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        self.isPending = true;
        if (self.customerContact.id) {
          customerService
            .updateContact(self.customerContact.id, {
              customerContact: self.customerContact
            })
            .then(res => {
              self.$alertify.success("Cập nhật thành công");
              self.$emit("submit:success", res.data, self.customer);
              if (type == 0) {
                self.visible = false;
              }
            })
            .finally(() => {
              self.isPending = false;
            });
        } else {
          customerService
            .createContact({
              customerContact: self.customerContact,
              customerId: self.customer.id
            })
            .then(res => {
              self.$alertify.success("Thêm thành công");
              self.customerContact = {};
              if (self.customer && self.customer.customerContacts)
                self.customer.customerContacts.push(res.data);
              self.$emit("submit:success", res.data, self.customer);
              if (type == 0) {
                self.visible = false;
                self.isPending = false;
              } else {
                self.isPending = false;
              }
            })
            .finally(() => {
              self.isPending = false;
            });
        }
      });
    },
    handleClose() {
      this.customerContact = {};
      this.visible = false;
    },
    setData(customer, customerContact) {
      this.customer = customer;
      if (customerContact) this.customerContact = customerContact;
    },
    evAdd() {
      this.customerContact = {};
      this.visible = true;
    }
  }
};
</script>

<style lang="scss">
.wrap-drop-img {
  height: 400px;
}
</style>
